import type { ChatChip } from "@mirage/analytics/events/enums/chat_chip";
import type { ClickableEmptyChatInstructionsOption } from "@mirage/mosaics/Chat/components/chat/instructions/EmptyChatInstructions";

/**
 * Maps ClickableEmptyChatInstructionsOption to ChatChip for analytics
 */
const CHAT_CHIP_MAP: Record<ClickableEmptyChatInstructionsOption, ChatChip> = {
  write: "write",
  chat_with_dash: "chat",
  "create-ai-tool": "create_ai_tool",
  "workflow-agent": "select_ai_tool",
  library: "library",
} as const;

/**
 * Converts a ClickableEmptyChatInstructionsOption to its corresponding ChatChip value
 * @param opt - The option to convert
 * @returns The corresponding ChatChip value
 * @throws Error if the option is not found in the mapping
 */
export const mapOptionToChatChip = (
  opt: ClickableEmptyChatInstructionsOption,
): ChatChip => {
  return CHAT_CHIP_MAP[opt] ?? "chat"; // Default to "chat" if not found
};
